import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { AppCrashFallback } from '@spotify/confidence-core-react';

export const RouterErrorFallback = () => {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error, {
      level: 'fatal',
      tags: { app_crash: true },
    });
  }, [error]);

  return <AppCrashFallback />;
};
